(function () {
    if (window.__storeListingsCarouselHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.storeListingsCarousel = window.Branch.storeListingsCarousel || {};
    window.Branch.storeListingsCarousel.sliders = window.Branch.storeListingsCarousel.sliders || {};
    window.__storeListingsCarouselHasFired = true;

    function initShowCarousel(storeListingsCarouselSection, parent){
        let postsContainer = storeListingsCarouselSection.querySelector('.store-listings-carousel__posts-container');
        postsContainer.setAttribute('data-show-carousel-initialized', 'true');
    }

    function initPartnersListingPopup(storeListingsCarouselSection, parent){
       let slides = storeListingsCarouselSection.querySelectorAll('.store-listings-carousel__item.swiper-slide');
       const dataScript = parent.querySelector('script.partner-listing-data[type="application/ld+json"]');

       if (!dataScript) {
         return;
       }

       let partnerData;
       try {
         partnerData = JSON.parse(dataScript.textContent);
       } catch (error) {
         console.error('Error parsing partner listing data:', error);
         return;
       }

       // Function to build dropdown options HTML for custom dropdown
       function buildDropdownOptions(currentHandle) {
         let optionsHTML = '';
         for (const handle in partnerData) {
           const selected = handle === currentHandle ? 'data-selected="true"' : '';
           // Format handle for display (replace hyphens with spaces and capitalize)
           const displayName = handle.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ').replaceAll('Nyc', 'NYC').replaceAll('Eq3', 'EQ3');
           optionsHTML += `<div class="partner-listing-popup__option" data-value="${handle}" ${selected}>${displayName}</div>`;
         }
         return optionsHTML;
       }

       // Function to get display name for current handle
       function getDisplayName(handle) {
         return handle.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ').replaceAll('Nyc', 'NYC').replaceAll('Eq3', 'EQ3');
       }

       // Function to build partner content (without wrapper)
       function buildPartnerContent(handle) {
         const data = partnerData[handle];

         if (!data) {
           console.error('No data found for handle:', handle);
           return '';
         }

         // Decode URL-encoded strings
         const address = decodeURIComponent(data.address.replace(/\+/g, ' '));
         const text = decodeURIComponent(data.text.replace(/\+/g, ' '));

         // Build featured products HTML
         let productsHTML = '';
         if (data.featured_products && data.featured_products.length > 0) {
           productsHTML = `<div class="partner-listing-popup__products swiper" data-items-count="${data.featured_products.length}"><div class="partner-listing-popup__products-inner swiper-wrapper">`;
           data.featured_products.forEach(product => {
             productsHTML += `
               <div class="partner-listing-popup__product swiper-slide">
                <a target="_blank" href="/products/${product.handle}">
                    <img src="${product.image_url}" alt="${product.title}" loading="lazy">
                    <h4>${product.title}</h4>
                 </a>
               </div>
             `;
           });
           productsHTML += '</div></div>';
         }

         return `
           <div class="partner-listing-popup__address">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="22" viewBox="0 0 15 22" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 0C3.35357 0 0 3.443 0 7.7C0 13.475 7.5 22 7.5 22C7.5 22 15 13.475 15 7.7C15 3.443 11.6464 0 7.5 0ZM7.50005 10.4494C6.02147 10.4494 4.82147 9.21746 4.82147 7.69949C4.82147 6.18153 6.02147 4.94956 7.50005 4.94956C8.97862 4.94956 10.1786 6.18153 10.1786 7.69949C10.1786 9.21746 8.97862 10.4494 7.50005 10.4494Z" fill="#314438"/>
              </svg>
             <a href="${data.maps_link}" target="_blank" rel="noopener noreferrer">${address}</a>
           </div>
           <div class="partner-listing-popup__description">
             <p>${text}</p>
           </div>
           <div class="partner-listing-popup__products-outer">
              <h3>Featured Products</h2>
              ${productsHTML}
              <div class="partner-listing-popup__products-nav-left  swiper-button-prev">
                  <svg aria-hidden="false" tabindex="-1" role="presentation" class=" icon icon-chevron" viewBox="0 0 32 32">
                      <path fill="#314438" fill-rule="evenodd" clip-rule="evenodd" d="M21.1199 16L7 1.93279L8.94004 0L25 16L8.94004 32L7 30.0672L21.1199 16Z"></path>
                  </svg>
              </div>
              <div class="partner-listing-popup__products-nav-right  swiper-button-next" >
                  <svg aria-hidden="false" tabindex="-1" role="presentation" class=" icon icon-chevron" viewBox="0 0 32 32">
                      <path fill="#314438" fill-rule="evenodd" clip-rule="evenodd" d="M21.1199 16L7 1.93279L8.94004 0L25 16L8.94004 32L7 30.0672L21.1199 16Z"></path>
                  </svg>
              </div>
           </div>
           <div class="partner-listing-popup__cta btn">
             <a href="${data.maps_link}" target="_blank" rel="noopener noreferrer">Take me there</a>
           </div>
         `;
       }

       // Function to build complete popup content HTML
       function buildPopupContent(handle) {
         return `
           <div class="partner-listing-popup__inner" style="max-width: 622px; margin: 0 auto;">
            <button class="partner-listing-popup__close" aria-label="Close">
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20" fill="#314438"></path></svg>
             </button> 
            <div class="partner-listing-popup__header">
               <h2>Partner Showroom</h2>
               <div class="partner-listing-popup__dropdown">
                <label class="partner-listing-popup__label">
                    Choose a location:
                </label>
                <div class="partner-listing-popup__custom-select">
                  <div class="partner-listing-popup__select-trigger" data-current-value="${handle}">
                    <span>${getDisplayName(handle)}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                      <path d="M5 6L0.669872 1.5L9.33013 1.5L5 6Z" fill="#314438"/>
                    </svg>
                  </div>
                  <div class="partner-listing-popup__options">
                    ${buildDropdownOptions(handle)}
                  </div>
                </div>
               </div>
             </div>
             <div class="partner-listing-popup__content-dynamic">
               ${buildPartnerContent(handle)}
             </div>
           </div>
         `;
       }

       // Function to update popup content
       function updatePopupContent(handle) {
         const contentContainer = document.querySelector('.partner-listing-popup__content-dynamic');
         if (contentContainer) {
           contentContainer.innerHTML = buildPartnerContent(handle);
           // Reinitialize Swiper after content update
           setTimeout(() => {
             initProductsSwiper();
           }, 100);
         }
       }

       // Store swiper instance
       let productsSwiper = null;

       // Function to initialize products swiper
       function initProductsSwiper() {
         const swiperElement = document.querySelector('.partner-listing-popup__products.swiper');

         // Destroy existing swiper instance if it exists
         if (productsSwiper && productsSwiper.destroy) {
           productsSwiper.destroy(true, true);
           productsSwiper = null;
         }

         if (swiperElement && typeof Swiper !== 'undefined') {
           productsSwiper = new Swiper('.partner-listing-popup__products', {
             slidesPerView: 1,
             spaceBetween: 12,
             navigation: {
                nextEl: `.partner-listing-popup__products-nav-right`,
                prevEl: `.partner-listing-popup__products-nav-left`,
            },
             breakpoints: {
               500: {
                 slidesPerView: 2,
                 spaceBetween: 12
               },
               700: {
                 slidesPerView: 3,
                 spaceBetween: 12
               }
             }
           });
         }
       }

       // Add event listeners to slides
       slides.forEach(slide => {
         const handle = slide.getAttribute('data-handle');

         if (handle && partnerData[handle]) {
           const anchor = slide.querySelector('a');

           if (anchor) {
             anchor.addEventListener('click', function(e) {
               e.preventDefault();
               e.stopPropagation();

               // Build popup content
               const content = buildPopupContent(handle);

               // Use Simplistic.openModal to open the popup
               if (window.Simplistic && window.Simplistic.openModal) {
                 window.Simplistic.openModal(content, 'partner-listing-popup', 'partner-listing', $(slide));

                 // Initialize Swiper and dropdown after modal is opened
                 setTimeout(() => {

                   const closeButton = document.querySelector('.partner-listing-popup__close');
                   if (closeButton) {
                     closeButton.addEventListener('click', function() {
                       const modal = document.querySelector('.tingle-modal');
                       if (modal && modal.classList.contains('tingle-modal--visible')) {
                         const closeBtn = modal.querySelector('.tingle-modal__close');
                         if (closeBtn) {
                           closeBtn.click();
                         }
                       }
                     });
                   }

                   initProductsSwiper();

                   // Add event listeners to custom dropdown
                   const selectTrigger = document.querySelector('.partner-listing-popup__select-trigger');
                   const customSelect = document.querySelector('.partner-listing-popup__custom-select');
                   const optionsContainer = document.querySelector('.partner-listing-popup__options');

                   if (selectTrigger && customSelect && optionsContainer) {
                     // Toggle dropdown open/close
                     selectTrigger.addEventListener('click', function(e) {
                       e.stopPropagation();
                       customSelect.classList.toggle('is-open');
                     });

                     // Handle option selection
                     const options = optionsContainer.querySelectorAll('.partner-listing-popup__option');
                     options.forEach(option => {
                       option.addEventListener('click', function(e) {
                         e.stopPropagation();
                         const selectedHandle = this.getAttribute('data-value');
                         const displayName = this.textContent;

                         // Update trigger text and value
                         selectTrigger.querySelector('span').textContent = displayName;
                         selectTrigger.setAttribute('data-current-value', selectedHandle);

                         // Update selected state
                         options.forEach(opt => opt.removeAttribute('data-selected'));
                         this.setAttribute('data-selected', 'true');

                         // Close dropdown
                         customSelect.classList.remove('is-open');

                         // Update content
                         updatePopupContent(selectedHandle);
                       });
                     });

                     // Close dropdown when clicking outside
                     document.addEventListener('click', function closeDropdown(e) {
                       if (!customSelect.contains(e.target)) {
                         customSelect.classList.remove('is-open');
                       }
                     });
                   }
                 }, 100);
               } else {
                 console.error('Simplistic.openModal is not available');
               }
             });

             // Update cursor to indicate clickable
             slide.style.cursor = 'pointer';
           }
         }
       });
    }

    async function getUserLocation() {
      try {
          var cached = localStorage.getItem('branchIpInfoData');
          var expiry = localStorage.getItem('branchIpInfoExpiry');
          var data;

          if (cached && expiry && Date.now() < parseInt(expiry, 10)) {
            data = JSON.parse(cached);
          } else {
            const response = await fetch('https://ipinfo.io/json?token=fcc331351b4fa3');
            data = await response.json();
            var ttl = window.innerWidth < 768 ? 48 * 3600000 : 15 * 86400000;
            localStorage.setItem('branchIpInfoData', JSON.stringify(data));
            localStorage.setItem('branchIpInfoExpiry', String(Date.now() + ttl));
          }

          const coords = data.loc.split(',');
          const userLatitude = parseFloat(coords[0]);
          const userLongitude = parseFloat(coords[1]);
          
          return {
            userLocation: {
                city: data.city,
                region: data.region,
                country: data.country,
                latitude: userLatitude,
                longitude: userLongitude
            }
          };
      } catch (error) {
          console.error('Error fetching location:', error);
          return {
            locationFound: false,
            error: error.message
          };
      }
    }

    function getDistanceMiles(lat1, lon1, lat2, lon2) {
        const R = 3958.8;
        const toRad = (deg) => deg * Math.PI / 180;

        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);

        const a =
            Math.sin(dLat / 2) ** 2 +
            Math.cos(toRad(lat1)) *
            Math.cos(toRad(lat2)) *
            Math.sin(dLon / 2) ** 2;

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c;
    }

    async function distanceFromUser(latitude, longitude, userLocation) {
        // console.log('userLocation', userLocation);
        const distanceInMiles = getDistanceMiles(
            userLocation.userLocation.latitude, userLocation.userLocation.longitude,
            latitude, longitude
        );
        // console.log('distanceInMiles', distanceInMiles)
        return distanceInMiles;
    }

    async function updateDistanceAway(storeListingsCarouselSection, parent){
       let slides = storeListingsCarouselSection.querySelectorAll('.store-listings-carousel__item.swiper-slide');
       let userLocation = await getUserLocation();
       for (const [index, slide] of slides.entries()) {
            let latitude = parseFloat(slide.getAttribute('data-latitude'));
            let longitude = parseFloat(slide.getAttribute('data-longitude'));
            // console.log('latitude', latitude)
            // console.log('longitude', longitude)
            let distanceAway = await distanceFromUser(latitude, longitude, userLocation);
            slide.querySelector('.store-listings-carousel__image-store_street_address').innerHTML = `${distanceAway.toFixed(1)} miles away`;
            slide.setAttribute('data-distance-away', parseInt(distanceAway));
       }
       
        // Sort slides by distance (closest first)
        const slidesArray = Array.from(slides);
        const swiperWrapper = storeListingsCarouselSection.querySelector('.swiper-wrapper');

        slidesArray.sort((a, b) => {
            const distanceA = parseInt(a.getAttribute('data-distance-away')) || Infinity;
            const distanceB = parseInt(b.getAttribute('data-distance-away')) || Infinity;
            return distanceA - distanceB;
        });
    
        // Reorder slides in the DOM
        slidesArray.forEach(slide => {
            swiperWrapper.appendChild(slide);
        });

        initShowCarousel(storeListingsCarouselSection, parent);
    }

    function resizeTitleTextElements(parent) {
        const titleElements = parent.querySelectorAll('.store-listings-carousel__image-title');

        if (titleElements.length === 0) return;

        titleElements.forEach(element => {
            element.style.removeProperty('height');
        });

        let maxHeight = 0;
        titleElements.forEach(element => {
            const height = element.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        titleElements.forEach(element => {
            element.style.height = `${maxHeight}px`;
        });
    }

    function initStoreListingsCarouselSlider(storeListingsCarouselSection, parent){
        let slides = storeListingsCarouselSection.querySelectorAll('.store-listings-carousel__item.swiper-slide')
        if(slides.length > 0){
          let cascadeIndex = parseInt(slides[0].getAttribute('data-cascade-order'));

          storeListingsCarouselSection.querySelectorAll('.store-listings-carousel__item.swiper-slide').forEach((updatedSlide, index) => {
          updatedSlide.setAttribute('data-cascade-order', `${cascadeIndex}`);
          const width = window.innerWidth;

          if (
              (width < 900 && index < 2) ||
              (width < 1024 && index < 3) ||
              (width >= 1024 && index < 4)
          ) {
              cascadeIndex++;
          }
      });
          let parentId = parent.getAttribute('id');
          let enable_autoscroll = storeListingsCarouselSection.getAttribute('data-enable-autoscroll') == 'true';
          let autoscroll_interval = 1000 * parseInt(storeListingsCarouselSection.getAttribute('data-autoscroll-interval'));
          let mobile_images_across = parseFloat(storeListingsCarouselSection.getAttribute('data-mobile-images-across'));
          let small_tablet_images_across = parseFloat(storeListingsCarouselSection.getAttribute('data-small-tablet-images-across'));
          let tablet_images_across = parseFloat(storeListingsCarouselSection.getAttribute('data-tablet-images-across'));
          let desktop_images_across = parseFloat(storeListingsCarouselSection.getAttribute('data-desktop-images-across'));
          console.log('mobile_images_across', mobile_images_across, 'desktop_images_across!', desktop_images_across)
          let autoplay = !enable_autoscroll ? false : {delay: autoscroll_interval, disableOnInteraction: true}
          
          window.Branch.storeListingsCarousel.sliders[`${parentId}`] = new Swiper(`#${parentId} .store-listings-carousel__slider`, {
              spaceBetween: 20,
              slidesPerView: mobile_images_across,
              autoplay: autoplay,
              touchRatio: 0.2,
              loop: false,
              slideToClickedSlide: false,
              preventClicks: false,
              preventClicksPropagation: false,
              observer: true,
              observeParents: true,
              navigation: {
                  nextEl: `#${parentId} .store-listings-carousel__nav-right`,
                  prevEl: `#${parentId} .store-listings-carousel__nav-left`,
              },
              breakpoints: {
                  600: {
                          slidesPerView: small_tablet_images_across,
                  },
                  900: {
                          slidesPerView: tablet_images_across,
                  },
                  1024: {
                          slidesPerView: desktop_images_across,
                  }
              },
              on: {
                  click: function(swiper, event) {
                      event.stopPropagation();
                  },
                  init: function(swiper) {
                      const parentContainer = swiper.el.closest('.store-listings-carousel__container-inner');
                      const navNext = swiper.navigation.nextEl;
                      const navPrev = swiper.navigation.prevEl;

                      if (parentContainer && navNext && navPrev) {
                          const isLocked = navNext.classList.contains('swiper-button-lock') ||
                                         navPrev.classList.contains('swiper-button-lock');

                          if (isLocked) {
                              parentContainer.setAttribute('data-nav-locked', 'true');
                          } else {
                              parentContainer.removeAttribute('data-nav-locked');
                          }
                      }
                  },
                  update: function(swiper) {
                      const parentContainer = swiper.el.closest('.store-listings-carousel__container-inner');
                      const navNext = swiper.navigation.nextEl;
                      const navPrev = swiper.navigation.prevEl;

                      if (parentContainer && navNext && navPrev) {
                          const isLocked = navNext.classList.contains('swiper-button-lock') ||
                                         navPrev.classList.contains('swiper-button-lock');

                          if (isLocked) {
                              parentContainer.setAttribute('data-nav-locked', 'true');
                          } else {
                              parentContainer.removeAttribute('data-nav-locked');
                          }
                      }
                  }
              }
          });
        }
    }

function actionsOnVisible(storeListingsCarouselSection, parent){
    // console.log('actionsOnVisible image carousel')
        storeListingsCarouselSection.setAttribute('data-interacted', true);
        window.Branch.nav.handleUpdateSrcSet(null, '.store-listings-carousel__image', '.store-listings-carousel__image-container', 900);     
        updateDistanceAway(storeListingsCarouselSection, parent);
        resizeTitleTextElements(parent);
        initStoreListingsCarouselSlider(storeListingsCarouselSection, parent);
        initPartnersListingPopup(storeListingsCarouselSection, parent);
        if(storeListingsCarouselSection.getAttribute('data-cta-to-open-browse-locations-popup') == 'true'){
            window.Branch.browseLocations.initBrowseLocationsPopup(storeListingsCarouselSection, parent, 'store-listings-carousel');
        }
    }    

function initImageCarouselCallback(storeListingsCarouselSection, parent, type){
        let fromLoad = storeListingsCarouselSection.closest('.homepage-content-container') && storeListingsCarouselSection.closest('.homepage-content-container').getAttribute('data-origin') == 'load';

        if(type == 'from-copy' && fromLoad == false){
            actionsOnVisible(storeListingsCarouselSection, parent);
        } else if(!storeListingsCarouselSection.closest('.homepage-content-container')) {
            actionsOnVisible(storeListingsCarouselSection, parent);
        } else {
            const scrollHandler = function () {
            const containerRect = {top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight};
            const targetRect = storeListingsCarouselSection.getBoundingClientRect();

            const isVisible =
                targetRect.bottom > containerRect.top &&
                targetRect.top < containerRect.bottom;

            if (
                isVisible &&
                storeListingsCarouselSection.getAttribute("data-interacted") !== "true"
            ) {
                actionsOnVisible(storeListingsCarouselSection, parent);
                storeListingsCarouselSection.setAttribute("data-interacted", "true");
                window.removeEventListener("scroll", scrollHandler);
            }
        };

        window.addEventListener("scroll", scrollHandler);
        }
    }

    window.Branch.storeListingsCarousel.storeListingsCarouselInitOnLoad = function(type){
        let storeListingsCarouselSections = document.querySelectorAll('.store-listings-carousel:not([data-initialized="true"])');
        storeListingsCarouselSections.forEach((storeListingsCarouselSection) => {
            let parent = storeListingsCarouselSection.closest('.shopify-section');
            storeListingsCarouselSection.setAttribute('data-initialized', true);
            if(type == 'from-copy'){
                 initImageCarouselCallback(storeListingsCarouselSection, parent, type)
            } else {
                 window.Branch.functions.fireOnUserInteraction(initImageCarouselCallback, '.homepage-content-container', storeListingsCarouselSection, storeListingsCarouselSection, parent);
             }
        })  
    }

    if (document.readyState === "complete") {
        window.Branch.storeListingsCarousel.storeListingsCarouselInitOnLoad('regular');
    } else {
        window.addEventListener("load", () => window.Branch.storeListingsCarousel.storeListingsCarouselInitOnLoad('regular'));
    }

    // Resize event listener with debounce
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            const storeListingsCarouselSections = document.querySelectorAll('.store-listings-carousel[data-initialized="true"]');
            storeListingsCarouselSections.forEach((storeListingsCarouselSection) => {
                const parent = storeListingsCarouselSection.closest('.shopify-section');
                if (parent) {
                    resizeTitleTextElements(parent);
                }
            });
        }, 250);
    });
  })();
